// LITRA explicit output — Sync track S1.
//
// Today LITRA chat output in the writing/edit/delivery phases AUTO-overwrites
// the editor chapters, gated by two heuristics: shouldSyncTextToManuscript
// (LiteraChat) and shouldLiteraArtifactReplaceChapters (book-project-sync, a
// stack of word-ratio guesses). Those gates exist only because there is no
// "the user decides" rule — they ARE the patch.
//
// With this flag ON, LITRA NEVER writes chapters automatically. Manuscript-worthy
// output is surfaced for an EXPLICIT user action (insert as a new chapter, or
// replace the active chapter). Both gates are bypassed in the ON path.
//
// Gated by VITE_FF_SYNC_EXPLICIT. Default OFF: only an explicit "true" enables it,
// so the default is bit-identical to today (clean rollback). Turned on together
// with the rest of the sync + token flags at S6.

/** Pure flag resolution: default OFF, only an explicit "true" enables it. */
export function isSyncExplicitEnabled(raw: string | undefined): boolean {
  return String(raw ?? "false").toLowerCase() === "true";
}

const flagRaw = (import.meta.env as Record<string, string | undefined>)
  .VITE_FF_SYNC_EXPLICIT;
/** Default OFF — only an explicit "true" makes LITRA output explicit. */
export const SYNC_EXPLICIT_ON = isSyncExplicitEnabled(flagRaw);

/** Minimum words before LITRA output is treated as a manuscript worth inserting. */
export const MANUSCRIPT_INSERT_MIN_WORDS = 120;

export function countWords(text: string): number {
  const t = text.trim();
  if (!t) return 0;
  return t.split(/\s+/).filter(Boolean).length;
}

/**
 * Is this cleaned LITRA output substantial enough to offer as a chapter insert?
 * Pure length check — NOT an overwrite heuristic. The user decides whether and
 * where to insert; this only decides whether to show the offer at all. A manuscript
 * marker ([BBG_MANUSCRIPT_START] in the raw output) always qualifies.
 */
export function isInsertableManuscript(cleaned: string, hasMarker: boolean): boolean {
  if (hasMarker) return true;
  return countWords(cleaned) >= MANUSCRIPT_INSERT_MIN_WORDS;
}
